import type { HTMLAttributes } from 'react';
import { get } from 'lodash';
import type { PageMeta } from '$util/types';
import { Title } from '@/components/atoms/Title';

export function getTitle(pathname: string) {
  if (pathname === 'locations') {
    return (
      <span>
        Your car&#39;s in safe hands at the <b>UK&#39;s top-rated garages</b>
      </span>
    );
  }
  if (pathname === 'how-it-works') {
    return <span>How it works</span>;
  }
  if (pathname === '/hammersmith') {
    return (
      <>
        Hassle-free car maintenance in <br /> Hammersmith and Fulham
      </>
    );
  }
  return '';
}

export const getSubTitle = ({ pageType, isFree, abTestCarServiceMake }: SubTitleProps, addMarkup = true) => {
  if (isFree) return 'Spot problems early with a free check';
  if (abTestCarServiceMake)
    return `The most efficient way to get a service—with same day collection and return from a ${get(
      pageType,
      '1.name',
      ''
    )} specialist. Save 30% vs dealerships.`;
  return addMarkup ? (
    <p>
      Get an <span>instant quote</span> and <span>save up to 30%</span>
    </p>
  ) : (
    'Get an instant quote and save up to 30%'
  );
};

export interface SubTitleProps extends HTMLAttributes<HTMLElement> {
  readonly pageType?: PageMeta[];
  readonly name?: string;
  readonly isFree?: boolean;
  readonly abTestCarServiceMake?: boolean;
}

export interface TopTitleProps extends HTMLAttributes<HTMLElement> {
  readonly pageTypeFromPath: string;
  readonly pathname: string;
}
/**
 * Main titles must remain as H1 and H2 to help SEO - see OPS-664
 * */
export function TopTitle({ pathname, pageTypeFromPath = '' }: TopTitleProps): JSX.Element {
  const [pathType] = pageTypeFromPath.split('/');

  switch (pathType) {
    case 'partner':
      return <Title className="partner-title">How it works</Title>;

    default:
      return (
        <Title size="xl" h={1} className="TopTitle">
          {getTitle(pathname)}
        </Title>
      );
  }
}

TopTitle.displayName = 'TopTitle';
